import React, {memo} from 'react';
import cx from 'classnames';

const GroupLabel = memo( ( {children, className, ...props} ) => {
    // console.log( '[GroupLabel]', children )
    return (
        <div {...props}
             className={cx( 'ut-search-suggestions-group-label', className )}>
        {children}
    </div>
    )
} )

export default GroupLabel;
